// 에러 이벤트에 함께 실리는 사용자 정보는 여기 열거한 것뿐이다. 학생·학원 객체를 통째로 넘기면 이름·전화번호와
// DTO 에 나중에 추가되는 필드까지 따라 나가므로, 재현에 필요한 식별자와 구분값만 allowlist 로 고정한다.

import type { Academy } from '@mathflat/domain/Academy'
import type { Student } from '@mathflat/domain/Student'
import type { UserType } from '@mathflat/domain/User'
import type { FwTag, ReportUser } from '@mathflat/shared/@modules/errorReporting'

type ReportContextInput = {
  studentId: Student['id']
  academyId: Academy['academyId']
  userType: UserType
  isSchoolflat: boolean
  isApp: boolean
}

export const buildReportContext = ({
  studentId,
  academyId,
  userType,
  isSchoolflat,
  isApp,
}: ReportContextInput): { user: NonNullable<ReportUser>; tags: Record<FwTag, string> } => ({
  user: { id: String(studentId) },
  tags: {
    'fw.brand': isSchoolflat ? 'schoolflat' : 'mathflat',
    'fw.platform': isApp ? 'webview' : 'web',
    'fw.user.role': userType,
    'fw.academy.id': String(academyId),
  },
})
